/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DeleteOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Input } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/supplier-bill/actions'
import { formatDateWithoutTime, getCustomerMenuSelect, numberWithComma, toDateQuery } from 'helpers/format'
import { SupplierInvoiceStatus } from 'helpers/constanst'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import SupplierInvoiceDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import { RangeDateItem, SelectItem } from 'Components/form'
import theme from 'Components/common/Theme'
import { selectAllSaleOrderCustomerList } from 'Store/saleorder-customer/selector'
import { SaleOrderCustomerListReq } from 'Store/saleorder-customer/types'
import { allSaleOrderCustomerListAPI } from 'Store/saleorder-customer/api'
import CreateBill from './components/CreateBill'
import { deleteSupplierBillAPI, supplierBillListAPI } from 'Store/supplier-bill/api'
import { DeleteSupplierBillReq, SupplierBillListData, SupplierBillListReq } from 'Store/supplier-bill/types'
import {
  selectSupplierBillActionEvent,
  selectSupplierBillList,
  selectSupplierBillListEvent,
} from 'Store/supplier-bill/selector'
import { ConfirmDailog } from 'Components/modal'

type Props = {} & ReduxProps

const SupplierBill: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event, customers } = props
  const dispatch = useDispatch()
  const [createDrawer, setCreateDrawer] = useState(false)
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')

  const [filter, setFilter] = useState({
    keyword: '',
    status: SupplierInvoiceStatus.EXPIRED,
    start_date: '',
    end_date: '',
    customer: 0,
    sort: 'desc',
    order_by: 'id',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetCustomerList = (): void => {
    const req: SaleOrderCustomerListReq = {
      page: 1,
      per_page: 10,
      all: true,
    }
    dispatch(
      allSaleOrderCustomerListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const onGetList = (): void => {
    const req: SupplierBillListReq = {
      keyword: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      sort: filter.sort || 'desc',
      order_by: filter.order_by || 'id',
    }

    if (filter.customer) {
      req.customer_id = filter.customer
    }
    dispatch(supplierBillListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onDelete = (id: number): void => {
    const req: DeleteSupplierBillReq = {
      id,
    }
    dispatch(deleteSupplierBillAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetCustomerList()
    }
  }, [])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onClickViewDetail = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onCreateSuccess = () => {
    setCreateDrawer(false)
    onGetList()
    clearEvent()
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  const renderActionButton = (text: string, record: SupplierBillListData) => {
    return (
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบข้อมูล"
        action="deleted"
        onClick={() => onClickDelete(record.id)}
      />
    )
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เลขที่ใบวางบิล',
      dataIndex: 'billing_note_no',
      key: 'billing_note_no',
      render: (val: string, record: SupplierBillListData) => (
        <LinkNo onClick={() => onClickViewDetail(record.id)}>{val}</LinkNo>
      ),
      sorter: true,
    },
    {
      title: 'ชื่อลูกค้า/คู่ค้า',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'เบอร์โทร',
      dataIndex: 'mobile',
      key: 'mobile',
      sorter: true,
    },
    {
      title: 'จำนวนเงิน',
      dataIndex: 'total_remain',
      key: 'total_remain',
      sorter: true,
      align: 'right',
      render: (val: number) => {
        return numberWithComma(val, true)
      },
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      width: '50px',
    },
    {
      title: 'วันที่ออกใบวางบิล',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (val: string) => formatDateWithoutTime(val || ''),
    },
    {
      width: '100px',
      title: 'ลบข้อมูล',
      key: 'action',
      align: 'center',
      render: renderActionButton,
    },
  ]

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const DetailDrawer = (
    <SupplierInvoiceDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {}}
      onPaymentSuccess={() => {}}
    />
  )

  const CreateDrawer = (
    <CreateBill
      visible={createDrawer}
      onCloseDrawer={() => setCreateDrawer(false)}
      onSuccess={onCreateSuccess}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={20}>
          <Row gutter={[8, 8]}>
            <Col md={7} xs={24}>
              <SearchInput
                placeholder="ค้นหาเลขที่ใบวางบิล"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col xs={24} md={7}>
              <SelectItem
                name={'customer'}
                label={''}
                isRequired={true}
                value={filter.customer}
                placeHolder={'ค้นหาลูกค้า/คู่ค้า'}
                menu={getCustomerMenuSelect(customers, 'name', 'id')}
                onChange={(val: any): void => onFilter('customer', val)}
              />
            </Col>
            <Col xs={24} md={7}>
              <RangeDateItem
                placeHolder={['วันที่ออกใบวางบิลเริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
        <MyCol>
          <PrimaryButton
            text="ออกใบวางบิล"
            btnType="Primary"
            onClick={() => {
              setCreateDrawer(true)
              setPageMode('create')
            }}
            icon={<PlusOutlined />}
          />
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      <HomePageLayout selected="supplier-billing-note" title="รายการใบแจ้งหนี้/ใบวางบิล" label="">
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          onSort={(field: string, order: string) => {
            onSort(field, order)
          }}
          scrollX={600}
        />
        {LoadingModal}
        {DetailDrawer}
        {CreateDrawer}
        {ConfirmDeleteModal}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectSupplierBillList(state),
    listEvent: selectSupplierBillListEvent(state),
    event: selectSupplierBillActionEvent(state),
    customers: selectAllSaleOrderCustomerList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

export default connect(mapStateToProps)(SupplierBill)
